import React, { useContext, useEffect, useState } from "react";
import Function from "../../../StateContext/Application";
import { Form } from "react-router-dom";
import CreateEmployee from "../Create Employee/CreateEmployee";

const EditViewEmp = () => {
  const types = useContext(Function);
  const { EmployeeManagement, Roles, DepartmentHandler } = types;
  const [Employees, SetEmployees] = useState([]);
  const [Search, SetSearch] = useState(null);
  const [searchdata, SetSearchData] = useState([]);
  const [Role, SetRole] = useState([]);
  const [DepartmentList, SetDepartment] = useState([]);
  var [form, setForm] = useState({
    type: "Edit",
    FullName: "",
    PhoneNumber: "",
    Email: "",
    Password: "",
    RoleID: "",
    Role: "",
    Department_ID: "",
    Department_Name: "",
  });
  useEffect(() => {
    GetData();
  }, []);
  const handleChange = (e) => {
    try {
      if (e.target.id === "Department_Name") {
        let obj = JSON.parse(e.target.value);
        form.Department_Name = obj.Department_Name;
        form.Department_ID = obj.Department_ID;
      } else if (e.target.id === "Role") {
        let obj = JSON.parse(e.target.value);
        form.Role = obj.Designation;
        form.RoleID = obj.RoleID;
      } else {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
      }
    } catch (error) {
      console.error('Error handling change:', error);
    }
  };
  async function GetData() {
    try {
      let data = await EmployeeManagement("View", Search);
      let data1 = await Roles("View", null);
      let department = await DepartmentHandler("view", null, null);
      SetDepartment(department);
      SetRole(data1);
      SetEmployees(data);
      SetSearchData(data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  function Display_Option(id) {
    try {
      let data = document.getElementById(id);

      if (data.style.display === "none") {
        data.style.display = "block";
      } else {
        data.style.display = "none";
      }
    } catch (error) {
      console.error('Error displaying option:', error);
    }
  }

  function Editing_Options(emp) {
    try {
      setForm(emp);
    } catch (error) {
      console.error('Error setting form:', error);
    }
  }

  const SearchEmployee = (e) => {
    try {
      let searchValue = e.target.value.toLowerCase();

      if (!searchValue) {
        SetEmployees(searchdata);
        return;
      }

      let newData = searchdata.filter((item) => {
        return (
          item.FullName.toLowerCase().includes(searchValue) ||
          item.PhoneNumber.toLowerCase().includes(searchValue) ||
          item.Email.toLowerCase().includes(searchValue) ||
          item.Password.toLowerCase().includes(searchValue) ||
          item.RoleID.toString().toLowerCase().includes(searchValue) ||
          item.Role.toLowerCase().includes(searchValue) ||
          item.Department_ID.toString().toLowerCase().includes(searchValue) ||
          item.Department_Name.toLowerCase().includes(searchValue)
        );
      });
      console.log(newData);
      SetEmployees(newData);
    } catch (error) {
      console.error('Error searching employees:', error);
    }
  };

  async function SubmitEdit() {
    try {
      let b = await EmployeeManagement("Update", form);
    } catch (error) {
      console.error('Error submitting edit:', error);
    }
  }

  return (
    <div className="container">
      <button
        className="btn btn-light"
        onClick={(e) => Display_Option("create_Employee")}
      >
        {" "}
        Create Employee
      </button>
      <div id="create_Employee" style={{ display: "none" }}>
        <CreateEmployee></CreateEmployee>
      </div>

      <Form onSubmit={GetData}>
        <div className="row mt-3">
          <div className="col-md-12">
            <span style={{ display: "flex", justifyContent: "center" }}>
              <input
                className="form-control"
                type="search"
                placeholder="Search Employees by Full Name/Email ID/Role ID"
                onChange={(e) => {
                  SearchEmployee(e);
                }}
              />
            </span>
          </div>
        </div>
      </Form>
      <div className="row">
        <div className="col-md-12">
          <table className="table table-striped">
            <thead>
              <tr>
                <th scope="col">Full Name</th>
                <th scope="col">Phone Number</th>
                <th scope="col">Email</th>
                <th scope="col">Password</th>
                <th scope="col">RoleID</th>
                <th scope="col">Role</th>
                <th scope="col">Department_ID</th>
                <th scope="col">Department_Name</th>
                <th scope="col">Acton</th>
              </tr>
            </thead>
            <tbody>
              {Employees &&
                Employees.map((emp, index) => (
                  <tr key={index}>
                    <td>{emp.FullName}</td>
                    <td>{emp.PhoneNumber}</td>
                    <td>{emp.Email}</td>
                    <td>{emp.Password}</td>
                    <td>{emp.RoleID}</td>
                    <td>{emp.Role}</td>
                    <td>{emp.Department_ID}</td>
                    <td>{emp.Department_Name}</td>
                    <td>
                      <button
                        href="#"
                        style={{ backgroundColor: "#e73d26", border: "none" }}
                        className="btn btn-danger"
                        onClickCapture={() => {
                          Editing_Options(emp);
                        }}
                        onClick={() => {
                          Editing_Options(emp);
                          Display_Option("edit_emp");
                        }}
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        {/* //Editing Form */}
        <div
          className="container my-5"
          id="edit_emp"
          style={{ display: "none" }}
        >
          <div className="card p-4">
            <h2 className="card-title text-center">Edit/View Employee</h2>
            <Form onSubmit={SubmitEdit}>
              <div className="mb-3">
                <label className="form-label">Full Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="FullName"
                  value={form.FullName}
                  onChange={handleChange}
                  required
                  placeholder="Enter Full Name Here"
                />
              </div>
              <div className="mb-3">
                <label className="form-label" hidden>
                  Profile Picture
                </label>
                <input
                  type="text"
                  className="form-control"
                  name="ProfilePic"
                  value={form.ProfilePic}
                  onChange={handleChange}
                  hidden
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Phone Number</label>
                <input
                  type="tel"
                  pattern="\d{10}"
                  minLength="10"
                  maxLength="10"
                  className="form-control"
                  name="PhoneNumber"
                  value={form.PhoneNumber}
                  onChange={handleChange}
                  onInput={(e) => {
                    let enteredValue = e.target.value;
                    enteredValue = enteredValue.slice(0, 10).replace(/\D/g, "");
                    e.target.value = enteredValue;
                  }}
                  placeholder="Enter Phone Number Here"
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Email</label>
                <input
                  type="email"
                  className="form-control"
                  name="Email"
                  value={form.Email}
                  onChange={handleChange}
                  placeholder="Enter Email Here"
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Password</label>
                <input
                  type="password"
                  className="form-control"
                  name="Password"
                  value={form.Password}
                  onChange={handleChange}
                  placeholder="Enter Password Here"
                />
              </div>
              <div className="mb-3">
                <label className="form-label">Select Department</label>

                <select
                  className="form-control"
                  id="Department_Name"
                  onChange={(e) => handleChange(e)}
                >
                  <option value={form.Department_ID}>
                    {form.Department_Name}
                  </option>
                  {DepartmentList.map((e) => {
                    return (
                      <option key={e.Department_ID} value={JSON.stringify(e)}>
                        {e.Department_Name}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label">Role</label>

                <select
                  className="form-control"
                  id="Role"
                  onChange={(e) => handleChange(e)}
                >
                  <option value={form.RoleID}>{form.Role}</option>
                  {Role.map((e) => {
                    return (
                      <option key={e.RoleID} value={JSON.stringify(e)}>
                        {e.Designation}
                      </option>
                    );
                  })}
                </select>
              </div>

              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditViewEmp;
